import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { replyListApiV1CollaborationAppReplyGetQueryKey } from '../gen/base'

export const useInvalidateReplyListQuery = () => {
    const queryClient = useQueryClient()

    return useCallback(() => {
        queryClient.invalidateQueries({
            predicate: (query) =>
                query.queryKey.some(
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-expect-error
                    (key) => key?.url === replyListApiV1CollaborationAppReplyGetQueryKey()[0].url,
                ),
        })
    }, [queryClient])
}
